import React, { useState } from "react";
import {
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Card,
  CardBody,
} from "reactstrap";
import classnames from "classnames";
import UserList from "./UserList";
import FileUploads from "./FileUploads";

const Tabs = () => {
  const [activeTab, setActiveTab] = useState("1");
  const [loading, setLoading] = useState(false);

  const toggleTab = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  return (
    <div className="user-management-page" style={{ borderRadius: "10px" }}>
      <Card className="shadow p-1 user-management-card" style={{ borderRadius: "10px" }}>
        <CardBody>
          <Nav tabs>
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === "1" })}
                onClick={() => toggleTab("1")}
                style={{ cursor: "pointer", color: "black" }}
              >
                <i className="bx bx-chat font-size-20 d-sm-none" />
                <span className="d-none d-sm-block">User List</span>
              </NavLink>
            </NavItem>

            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === "2" })}
                onClick={() => toggleTab("2")}
                style={{ cursor: "pointer", color: "black" }}
              >
                <i className="bx bx-group font-size-20 d-sm-none" />
                <span className="d-none d-sm-block">Uploads</span>
              </NavLink>
            </NavItem>
          </Nav>

          <div>
            <TabContent activeTab={activeTab}>
              <TabPane tabId="1">
                <UserList activeTab={activeTab} />
              </TabPane>
              <TabPane tabId="2">
                <FileUploads activeTab={activeTab} />
              </TabPane>
            </TabContent>
          </div>
        </CardBody>
      </Card>
    </div>
  );
};

export default Tabs;
